import {useRouter} from 'next/router';
import {useEffect} from 'react';

import {useI18n} from '@udemy/i18n';
import {
    type AlertBannerProps,
    type AlertLevel,
    ToasterStore,
} from '@udemy/react-messaging-components';

import {removeUrlSearchParam} from 'src/utils/remove-url-search-param';

export const CLAIM_RESULT_PARAM = 'retention-promo-claim';

/**
 * Reads the retention promo claim result from the URL and surfaces it via the
 * layout Toaster. Renders nothing itself.
 */
export const RetentionPromoClaimAlert = () => {
    const {gettext} = useI18n();
    const router = useRouter();

    useEffect(() => {
        const result = new URLSearchParams(window.location.search).get(CLAIM_RESULT_PARAM);
        if (!result) {
            return;
        }

        const successTitle = gettext(
            'Success! Your Personal Plan is locked in at your new price for the next year.',
        );
        const successBody = gettext(
            "We'll charge your card on your renewal date, and you can cancel anytime before then. You've made the right call — and momentum's only going to pick up from here!",
        );
        const messages: Record<string, {title: string; body?: string; udStyle: AlertLevel}> = {
            succeeded: {title: successTitle, body: successBody, udStyle: 'success'},
            already_claimed: {title: successTitle, body: successBody, udStyle: 'success'},
            expired: {title: gettext('Sorry, this offer has expired.'), udStyle: 'error'},
            failed: {
                title: gettext('Sorry, something went wrong. Please try again later.'),
                udStyle: 'error',
            },
        };
        const message = messages[result];
        if (!message) {
            return;
        }

        const bannerProps: AlertBannerProps = {
            udStyle: message.udStyle,
            title: message.title,
            body: message.body,
            actionButtonProps: false,
            onDismiss: () => removeUrlSearchParam(router, CLAIM_RESULT_PARAM),
        };

        ToasterStore.addAlertBannerToast(bannerProps, {
            autoDismiss: false,
            toastKey: `${CLAIM_RESULT_PARAM}-${result}`,
        });
    }, [gettext, router]);

    return null;
};
